import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { ReportService } from "src/app/core/services/report.service";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { ReportOption } from "src/app/shared/models/enums/ReportOption.enum";

@Component({
	selector: "app-reports-header",
	templateUrl: "./reports-header.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ReportsHeaderComponent implements OnInit {
	@Input() endDate: any = new Date();
	@Output() endDateChange = new EventEmitter<any>();

	@Input() startDate: any = new Date();
	@Output() startDateChange = new EventEmitter<any>();

	@Input() revenueCenter: number;
	@Output() revenueCenterChange = new EventEmitter<number>();

	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	@Output() reportRunChange = new EventEmitter<any>();

	reportOptions: {
		label: string;
		ngModel: string;
		options?: string;
		optionLabel?: string;
		optionValue?: string;
		type: string;
		sortOrder: number;
	}[] = [];

	constructor(public app: AppService, public reportService: ReportService) {}

	ngOnInit(): void {
		this.buildReportOptions();
	}

	buildReportOptions() {
		Object.keys(ReportOption).forEach((option) => {
			if (this.report.options.some((i) => i === ReportOption[option])) {
				switch (ReportOption[option]) {
					case ReportOption.EMPLOYEE: {
						this.reportOptions.push({
							label: "Employee",
							ngModel: "employee",
							options: "reportService.employees.value",
							optionLabel: "NickName",
							optionValue: "ID",
							type: "dropdown",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.ENDDATE: {
						console.log(option);
						this.reportOptions.push({
							label: "End Date",
							ngModel: "endDate",
							type: "calendar",
							sortOrder: 20,
						});
						break;
					}
					case ReportOption.ENDTIME: {
						this.reportOptions.push({
							label: "End Time",
							ngModel: "endTime",
							type: "time",
							sortOrder: 21,
						});
						break;
					}
					case ReportOption.JOB: {
						this.reportOptions.push({
							label: "Job",
							ngModel: "job",
							options: "reportService.jobs.value",
							optionLabel: "Name",
							optionValue: "ID",
							type: "dropdown",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.MENUITEM: {
						this.reportOptions.push({
							label: "Menu Items",
							ngModel: "menuItems",
							options: "reportService.menuItems.value",
							optionLabel: "MenuName",
							optionValue: "RecordNumber",
							type: "multiSelect",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.ORDERTYPE: {
						this.reportOptions.push({
							label: "Order Type",
							ngModel: "orderType",
							options: "reportService.orderTypes.value",
							optionLabel: "Name",
							optionValue: "ID",
							type: "dropdown",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.PAYMENT: {
						this.reportOptions.push({
							label: "Payment",
							ngModel: "payment",
							options: "reportService.payments.value",
							optionLabel: "Name",
							optionValue: "ID",
							type: "dropdown",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.REVENUECENTER: {
						this.reportOptions.push({
							label: "Revenue Center",
							ngModel: "revenueCenter",
							options: "reportService.revenueCenter.value",
							optionLabel: "Name",
							optionValue: "ID",
							type: "dropdown",
							sortOrder: 50,
						});
						break;
					}
					case ReportOption.STARTDATE: {
						this.reportOptions.push({
							label: "Start Date",
							ngModel: "startDate",
							type: "calendar",
							sortOrder: 10,
						});
						break;
					}
					case ReportOption.STARTTIME: {
						this.reportOptions.push({
							label: "Start Time",
							ngModel: "startTime",
							type: "time",
							sortOrder: 11,
						});
						break;
					}
				}
			}
		});

		this.reportOptions.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
	}

	onCalendarSelect(event, inputVal) {
		switch (inputVal) {
			case "startDate": {
				this.startDate = this.app.moment(event);
				this.startDateChange.emit(this.startDate);
				break;
			}
			case "endDate": {
				this.endDate = this.app.moment(event);
				this.endDateChange.emit(this.endDate);
				break;
			}
		}
	}
}
